/** @public */
export enum PromptFailedToShowReason {
    NOT_AVAILABLE = 'not_available',
    OTHER_PROMPT_SHOWING = 'other_prompt_showing',
    ALREADY_SHOWING = 'already_showing',
    USER_INELIGIBLE = 'user_eligible',
}
